export type Primitive = null | undefined | string | number | boolean | symbol | bigint

/**
 *
 * 사용자 정의 리터럴과 일반 리터럴 타입을 결합 (자동완성가능)
 * @see https://github.com/sindresorhus/type-fest/blob/main/source/literal-union.d.ts
 */
export type LiteralUnion<LiteralType, BaseType extends Primitive> = LiteralType | (BaseType & Record<never, never>)

/**
 * 특정 필드를 optional에서 required로 변경
 */
export type FieldRequired<T, K extends keyof T> = T & Required<Pick<T, K>>

/**
 * YYYY-MM-DD
 */
export type CommonDate = string

/**
 * YYYY-MM
 */
export type CommonMonthDate = string

/**
 * YYYY-MM-DDTtt:tt:tt
 */
export type DetailDate = string

/** 업권정보 */
export enum Industry {
    /** 은행 */
    BANK = 'bank',
    /** 카드 */
    CARD = 'card',
    /** 금융투자 */
    INVEST = 'invest',
    /** 보험 */
    INSU = 'insu',
    /** 전자금융 */
    EFIN = 'efin',
    /** 할부금융 */
    CAPITAL = 'capital',
    /** 보증보험 */
    GINSU = 'ginsu',
    /** 통신 */
    TELECOM = 'telecom',
}

export const IndustryName = {
    [Industry.BANK]: '은행',
    [Industry.CARD]: '카드',
    [Industry.INVEST]: '증권',
    [Industry.INSU]: '보험',
}

/** 기관타입 */
export enum OrgType {
    /** 정보제공자 */
    CODE_01 = '01',
    /** 정보제공자 */
    CODE_02 = '02',
    /** 마이데이터사업자 */
    CODE_03 = '03',
    /** 중계기관 */
    CODE_04 = '04',
    /** 통합인증기관 */
    CODE_05 = '05',
    /** 통합인증기관 */
    CODE_06 = '06',
    /** 기타 */
    CODE_99 = '99',
}

export enum AssetType {
    CARD = 'card', // 카드
    DEPOSIT = 'deposit', // 수신계좌
    FUND = 'fund', // 투자상품계좌
    INVEST = 'invest', // 증권계좌
    LOAN = 'loan', // 대출계좌
    IRP = 'irp', // 연금계좌
    INSU = 'insu', // 보험
    GINSU = 'ginsu', // 보증보험
    DC = 'dc', // DC형 자산
    ISA = 'isa', // ISA 자산
    TELECOM = 'telecom', // 통신
    PAID = 'paid', //  전금 계정
    PREPAID = 'prepaid', // 전금 선불
}
